// Comissão da angariação (ponto 11 do plano, Sónia, 29/10/2026).
// Por defeito: 5% para valores de 100 000 € ou mais; 5 000 € fixos abaixo de 100 000 €. As duas são editáveis.
export const LIMITE = 100000, PCT_DEFEITO = 5, FIXO_DEFEITO = 5000;

// a regra por defeito para um valor de venda
export const comissaoPorDefeito = (valor) => (Number(valor) >= LIMITE ? { tipo: "percentagem", valor: PCT_DEFEITO } : { tipo: "fixo", valor: FIXO_DEFEITO });

// a comissão desta angariação: a escolhida (se foi alterada) ou a regra por defeito; e o valor em euros
export function comissaoAngariacao({ valorVenda, tipo, valor }) {
  const base = Number(valorVenda) || 0;
  const c = tipo ? { tipo, valor: Number(valor) || 0 } : comissaoPorDefeito(base);
  const euros = c.tipo === "percentagem" ? Math.round(base * c.valor) / 100 : c.valor;
  return { ...c, euros, porDefeito: !tipo };
}
